import React, { SVGProps } from 'react';

export const SearchIconLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="30" height="30" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 1.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75a9.7 9.7 0 0 0 6.344-2.346l4.126 4.126a.75.75 0 1 0 1.06-1.06l-4.126-4.126A9.7 9.7 0 0 0 20.75 11c0-5.385-4.365-9.75-9.75-9.75M2.75 11a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0"
      clipRule="evenodd"
    />
  </svg>
);
